// src/firebase.ts
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";


const firebaseConfig = {
  // Your Firebase config here
  apiKey: "AIzaSyAgf1zC-16nxpEnEycWIQvRz-28yQ8wUBw",
  authDomain: "prgcars-a7548.firebaseapp.com",
  projectId: "prgcars-a7548",
  storageBucket: "prgcars-a7548.appspot.com",
  messagingSenderId: "774294443756",
  appId: "1:774294443756:web:ae6341df5206dbe02037c9"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);